'use strict';
import moment from 'moment-timezone';
angular.module('docketbook').
	controller('newGroupModalController', function (userService, $rootScope, $scope, $state, $stateParams, $mdpDatePicker, $mdpTimePicker, $mdToast, accessControl, $timeout, geolocation) {
		$scope.allTimezones = moment.tz.names();

		$scope.$parent.createNewGroupFromParent = function (parent, successCb) {
			$scope.newGroupCallback = successCb;
			$scope.parentGroup = parent;
			$scope.newGroup = {};
			$scope.newGroup.currentStep = 1;
			$scope.newGroup.process = 'form';
			$scope.newGroup.stepCount = 2;
			$scope.newGroup.showFullAddress = false;
			$scope.newGroup.timezone = parent.timezone;
			$("#newGroupModal").fadeIn(100);
		}

		$scope.closeNewGroupModal = function () {
			$("#newGroupModal").fadeOut(100);
			$scope.newGroupCallback(null);
		}

		$scope.newGroupNext = function () {
			$scope.newGroup.currentStep += 1;
			$timeout(function () {
				$("#editGroupFormStep" + $scope.newGroup.currentStep + " input:enabled:visible:first").focus();
			}, 200);
		}

		$scope.newGroupBack = function () {
			$scope.newGroup.currentStep -= 1;
		}

		$scope.newGroupManualAddress = function () {
			$scope.newGroup.showFullAddress = !$scope.newGroup.showFullAddress;
		}

		$scope.$watch('newGroup.address', function () {
			var requiredFields = ['streetName', 'suburb', 'state', 'postCode', 'country'];
			var incorrectFields = [];
			if ($scope.newGroup && $scope.newGroup.address) {
				for (var i = 0; i < requiredFields.length; i++) {
					if ($scope.newGroup.address[requiredFields[i]] == null || $scope.newGroup.address[requiredFields[i]] == "") {
						incorrectFields.push(requiredFields[i]);
					}
				}
				if (incorrectFields.length > 0) {
					$scope.newGroup.addressAlert = true;
				} else {
					$scope.newGroup.addressAlert = false;
				}
			}
		});

		$scope.createNewGroup = function (newGroup) {
			$scope.newGroup.process = 'creating';
			$scope.newGroup.loading = true;
			$scope.newGroup.publicName = $scope.newGroup.name;
			var owners = $scope.parentGroup.owners.map(function (owner) {
				if (owner.id) {
					return owner.id;
				} else {
					return owner;
				}
			});
			$scope.newGroup.owners = owners;
			$scope.newGroup.parent = $scope.parentGroup.id;
			userService.saveOrganisationGroup($scope.newGroup, function (groupSaved) {
				$scope.newGroup.process = 'success';
				$scope.newGroup.groupCreated = groupSaved;
			}, function (err) {
				if (err.data.message === "Not allowed to create more groups for for organisation according to current plan/usage.") {
					$scope.alertService.presentAutoAlert('saveOrgGroupExceed', err);
					$("#newGroupModal").fadeOut(100);
				} else if (err.data.message === "Not allowed to create organisation groups on this plan") {
					$scope.alertService.presentAutoAlert('saveOrgGroupDisallowed', err);
					$("#newGroupModal").fadeOut(100);
				} else if (err.data.message === "Not allowed to create more than 5 organisation groups in a sample company") {
					$scope.alertService.presentAutoAlert('saveOrgGroupSample', err);
					$("#newGroupModal").fadeOut(100);
				} else {
					$scope.alertService.presentAutoAlert('saveOrgGroup', err);
				}
				$scope.newGroup.loading = false;
				$scope.newGroup.process = 'form';
			});
		}

		$scope.newGroupFinish = function () {
			$("#newGroupModal").fadeOut(100);
			$scope.newGroupCallback($scope.newGroup.groupCreated);
		}
	});



// WEBPACK FOOTER //
// ./src/controllers/modals/newGroupModalController.js